export default __webpack_public_path__ + "static/media/video2.7d69db1a.svg";